import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  private groupSummaryObserver: MutationObserver | null = null;
  private rafId: number | null = null;

  constructor(private ngZone: NgZone) {}

  ngOnInit() {
    this.setupGroupSummaryColorizer();
  }

  ngOnDestroy() {
    if (this.groupSummaryObserver) this.groupSummaryObserver.disconnect();
    if (this.rafId) cancelAnimationFrame(this.rafId);
  }

  private setupGroupSummaryColorizer(): void {
    this.ngZone.runOutsideAngular(() => {
      this.groupSummaryObserver = new MutationObserver(() => {
        if (this.rafId) cancelAnimationFrame(this.rafId);
        this.rafId = requestAnimationFrame(() => this.colorizeGroupSummaries());
      });
      this.groupSummaryObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }

  private colorizeGroupSummaries(): void {
    const cells = document.querySelectorAll('.dx-group-row .dx-group-cell');
    cells.forEach((cell: Element) => {
      if (cell.querySelector('.group-summary-green')) return;
      const text = cell.textContent || '';
      const match = text.match(/ (\(.+\))$/);
      if (!match) return;
      const summary = match[1];
      const main = text.slice(0, -(summary.length + 1));
      cell.textContent = '';
      cell.appendChild(document.createTextNode(main + ' '));
      const span = document.createElement('span');
      span.className = 'group-summary-green';
      span.style.color = '#a2df4b';
      span.style.fontWeight = '600';
      span.textContent = summary;
      cell.appendChild(span);
    });
  }
}
